import React from 'react';

import { IIconProps } from 'assets/icons/IconProps';

export const CheckIcon = ({
  width = 16,
  height = 16,
  stroke = '#A0A4A8',
  strokeWidth = 1.7,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M13.3332 4L5.99984 11.3333L2.6665 8"
    />
  </svg>
);
